<script>
import { h, provide, ref } from 'vue'
import institutionTemplate from './components/institution-template.vue'
import templateGroup from '../components/template-group.vue'
import { ElTabs, ElTabPane } from 'element-plus'
import type from '@/common/utils/type'
export default {
  setup () {
    const institutionTemplateCom = ref(null)
    const tabs = {
      activeName: 'institutionTemplate',
      tabs: [
        { label: '企业模板', name: 'institutionTemplate', component: institutionTemplate, ref: institutionTemplateCom },
        { label: '模板类型', name: 'templateGroup', component: templateGroup }
      ]
    }
    provide('reloadTemplate', () => institutionTemplateCom.value.searchData())

    return {
      tabs
    }
  },
  render () {
    return h(
      ElTabs, {
        modelValue: this.tabs.activeName
      }, () => this.tabs.tabs.map(item => {
        return h(ElTabPane, {
          name: item.name,
          label: item.label
        }, () => [
          h(item.component, {
            ref: item.ref || '',
            type: type().templateGroupType.institution
          })
        ])
      })
    )
  }
}
</script>
<style lang="scss" scoped>
</style>
